import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { MyPurchaseHistoryApiParams } from "@NA/Services/GetMyPurchaseHistory";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import MyPurchaseHistoryConfigState from "@NA/Store/Data/ADIMyPurchaseHistoryConfigState";

type HandlerType = CustomApiHandler<MyPurchaseHistoryApiParams, MyPurchaseHistoryConfigState>;

export const PopulateMyPurchaseHistoryConfigParam: HandlerType = props => {
    props.apiParameter = props.parameter;
    props.dispatch({
        type: "Custom/MyPurchaseHistory/PopulateConfigParam",
    });
};

export const CleanMyPurchaseHistoryConfig: HandlerType = props => {
    props.dispatch({
        type: "Custom/MyPurchaseHistory/CleanConfig",
    });
};

export const SetMyPurchaseHistoryConfig: HandlerType = props => {
    props.dispatch({
        type: "Custom/MyPurchaseHistory/SetConfig",
        result: props.apiParameter,
    });
};

export const chain = [PopulateMyPurchaseHistoryConfigParam, CleanMyPurchaseHistoryConfig, SetMyPurchaseHistoryConfig];

const setPurchaseHistoryConfig = createHandlerChainRunner(chain, "SetPurchaseHistoryConfig");

export default setPurchaseHistoryConfig;
